import { NgModule } from '@angular/core';
import { NaForm } from './validators/na-form';
import { NaPipeModule } from './pipes/na-pipe.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NotificationModule } from './notification/notification.module';

@NgModule({
  imports: [FormsModule, ReactiveFormsModule],
  exports: [FormsModule, NotificationModule, ReactiveFormsModule, NaPipeModule],
  providers: [NaForm],
})
export class NaFormsModule {}
